"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialDataMapper = initialDataMapper;
function initialDataMapper(template, chatInfo) {
    var _a, _b;
    const physicianInfo = (_b = (_a = chatInfo.info) === null || _a === void 0 ? void 0 : _a.physician) === null || _b === void 0 ? void 0 : _b[0];
    if (physicianInfo === null || physicianInfo === void 0 ? void 0 : physicianInfo.name)
        template.initialData.physicianName = physicianInfo.name;
    return template;
}
